/**
 * @file BooleanField.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since May 22, 2020 20:36
 */
import PropTypes from 'prop-types';

import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';

function VeriomeBooleanField(props) {
    const {
        fieldErrors,
        fieldLabel,
        fieldName,
        currentValue,
        helpText = '',
        isFocus = false,
        isDisabled = false,
        isRequired = false,
        sxStyle = null,
        handleBlur = () => { },
        handleChange,
    } = props;

    return (
        <FormControl
            error={fieldName ? Boolean(fieldErrors[fieldName]) : false}
            sx={sxStyle}
        >
            <FormGroup >

                <FormControlLabel
                    sx={{
                        mt: '7px',
                    }}
                    control={
                        <Checkbox
                            sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 },
                            }}
                            key={`${fieldName}-key`}
                            id={`${fieldName}-field`}
                            name={`${fieldName}-field`}
                            checked={Boolean(currentValue)}
                            disabled={isDisabled}
                            color="secondary"
                            autoFocus={isFocus}
                            required={isRequired}
                            value={Boolean(currentValue)}
                            onChange={(event) => {
                                handleChange(event, fieldName);
                            }}
                            onBlur={() => {
                                handleBlur();
                            }}
                        />}
                    label={fieldLabel}
                    labelPlacement="end"
                />
            </FormGroup>

            <FormHelperText>{fieldErrors[fieldName] || helpText}</FormHelperText>
        </FormControl >
    )

}

VeriomeBooleanField.propTypes = {
    fieldErrors: PropTypes.object.isRequired,
    fieldLabel: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    currentValue: PropTypes.bool.isRequired,
    helpText: PropTypes.string,
    isFocus: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool.isRequired,
    sxStyle: PropTypes.object,
    handleBlur: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default VeriomeBooleanField;